<template lang="pug">
k-page.post.about( :key='postData.id' )
  d-main-image( v-bind=`{ img, show }` @load='pageLoaded' )
  w-go-down
  k-main( :title='title' )
    section.description( v-html='content' )
    section.post( v-for='post in posts' :key='post.id' )
      h2.title.fancy-title( v-html='postTitle( post )' )
      .content( v-html='postContent( post )' )
</template>

<script lang="js">
import _wpapix from '@/lib/wpapix'
import KPage from '@/blocks/k-page'
import KMain from '@/blocks/k-main'
import DMainImage from '@/displays/d-main-image'
import WGoDown from '@/widgets/w-go-down'
import { PostList } from '@/mixins'

export default {
  name: 'AboutPage',
  mixins: [ PostList ],
  components: { KPage, KMain, DMainImage, WGoDown },
  props: [],
  data() {
    return {
    }
  },
  created() {},
  mounted() {
    _wpapix.then( wpapix => {
      var path = new wpapix.Path({ path: 'about-us' })
      path.fetch().done(( rpost ) => {
        console.log( 'got about page', rpost )
        this.storedPost = rpost
      })
    })
  },
  methods: {},
  computed: {},
  watch: {
    $route( to, from ) {
      // TODO: scroll to post (and maybe fetch)
    }
  }
}
</script>

<style lang="scss">
.about {

}
</style>
